// React component to show action when no expenses

import React, { useState } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { ReactComponent as SettlementsIcon } from './../../../assets/icons/emptySettlements.svg';
import AddIcon from '@mui/icons-material/Add';
import { TwButton, TwButtonType } from '../../TwButtons/TwButtons';
import CreateOrEditOtheExpenseForm from '../../../pages/OtherExpenses/CreateOrEditExpense/CreateOrEditExpense';

export interface NoExpensesProps {
  label: string;
  tripId?: string;
  readableTripId?: string;
  token?: string;
  isDriverLink?: boolean;
  driver?: { id: string; name: string };
  setMutatedExpenses: (mutated: boolean) => void;
}

const NoExpenses: React.FC<NoExpensesProps> = ({
  label,
  tripId,
  readableTripId,
  token,
  isDriverLink,
  driver,
  setMutatedExpenses
}) => {
  const [openCreateOtherExpense, setOpenCreateOtherExpense] = useState(false);

  const handleCloseAddOtherExpenseDialog = (changed: boolean): void => {
    setOpenCreateOtherExpense(false);
    setMutatedExpenses(changed);
  };

  return (
    <>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%', height: '100%', padding: '16px' }}
        spacing={2}
      >
        <SettlementsIcon style={{ height: '48px', width: '48px' }} />
        <Typography
          variant="body2"
          fontWeight="400"
          fontSize="14px"
          color="#6B7280"
          marginRight="4px"
        >
          {label}
        </Typography>
        <TwButton
          key="1"
          type={TwButtonType.secondary}
          label="New expense"
          sx={{
            textTransform: 'none'
          }}
          startIcon={<AddIcon />}
          action={(): void => {
            setOpenCreateOtherExpense(true);
          }}
        />
      </Stack>

      {openCreateOtherExpense && (
        <CreateOrEditOtheExpenseForm
          open={openCreateOtherExpense}
          onClose={handleCloseAddOtherExpenseDialog}
          otherExpenseId={null}
          tripId={tripId}
          readableTripId={readableTripId}
          token={token}
          isDriverLink={isDriverLink}
          driver={driver}
        />
      )}
    </>
  );
};

export default NoExpenses;
